import { useRef } from "react";
import { Box } from "@mui/material";
import CommentsDisabledIcon from "@mui/icons-material/CommentsDisabled";

export const NoRowsComponent = ({ noRowsMessage }: { noRowsMessage?: string }) => {
    const boxRef = useRef(null);
    const isHeightLessThan30 = boxRef.current?.offsetHeight < 30;
    const isHeightLessThan100 = boxRef.current?.offsetHeight < 100;
    const fontSize = isHeightLessThan30 ? 20 : isHeightLessThan100 ? 30 : 80;
    const boxFlexDirection = isHeightLessThan100 ? "row" : "column";

    return (
        <Box
            ref={boxRef}
            sx={{
                alignItems: "center",
                display: "flex",
                flexDirection: boxFlexDirection,
                height: "100%",
                alignContent: "center",
                justifyContent: "center",
                width: "100%",
                mt: 0.5,
            }}
        >
            {" "}
            <CommentsDisabledIcon sx={{ fontSize, color: "#dce0e6", mr: 1 }} />
            <Box sx={{ mt: !isHeightLessThan100 && 1 }}>{noRowsMessage ?? "No Rows Available"}</Box>
        </Box>
    );
};
